import { render, staticRenderFns } from "./InvitationsTile.vue?vue&type=template&id=eb806d5a&scoped=true&lang=pug&"
import script from "./InvitationsTile.vue?vue&type=script&lang=js&"
export * from "./InvitationsTile.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsTile.vue?vue&type=style&index=0&id=eb806d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb806d5a",
  null
  
)

export default component.exports